import { BusinessHomepageLayout } from "./BusinessHomepageLayout";
import { FaqPage } from "./pages/FaqPage";

export default function BusinessFaqPage() {
	return (
		<BusinessHomepageLayout>
			<FaqPage />
		</BusinessHomepageLayout>
	);
}
